import React from "react";
import { forgotTwo } from "../../actions/user";
import { connect } from "react-redux";
import { tempAlWait } from "../../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";

class ForgotPwdTwo extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        form: {
            email: '',
            code: '',
            mdp: '',
            mdpConf: ''
        },
        codeFocus: false,
        mdpFocus: false,
        mdpConfFocus: false
    }

    componentDidMount() {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                email: this.props.email
            }
        }))
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }
        
        if (this.props.redFgtPwdTwo != prevProps.redFgtPwdTwo) {
            this.setState({
                alert: this.props.redFgtPwdTwo.alert
            })
            if (this.props.redFgtPwdTwo.alert.type == "succ") {
                this.props.changeStep("signin");
            }
        }
    } 

    handleForgot = (el) => {
        el.preventDefault();
        this.props.forgotTwo({
            email: this.state.form.email,
            code: this.state.form.code,
            mdp: this.state.form.mdp,
            mdpconf: this.state.form.mdpConf
        })
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <div className={`signin ${this.props.otherClass != null && `signin--${this.props.otherClass}`}`}>
            <h2 className="signin__ttl">Mot de passe oublié</h2>
            <form className="signin__form">
                <p className="signin__help signin__help--noitalic">Vous avez reçu un code sur votre boîte mail. Si vous ne le voyez pas, vérifiez dans vos spams.</p>
                <p className="signin__help">* champs obligatoires</p>

                {/** Code **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir le code reçu par e-mail"
                    aria-label="Assurez-vous de saisir le code reçu par e-mail"
                >
                    <label
                        htmlFor="forgot-two-code"
                        className={`signin__lab ${(this.state.codeFocus || this.state.form.code != '') && "signin__lab--reduce"}`}
                    >
                        Code *
                    </label>
                    <input
                        type="text"
                        className="signin__inp"
                        id="forgot-two-code"
                        required
                        value={this.state.form.code}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    code: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({codeFocus: true})}
                        onBlur={() => this.setState({codeFocus: false})}
                    />
                </div>

                {/** Mot de passe **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir un mot de passe"
                    aria-label="Assurez-vous de saisir un mot de passe"
                >
                    <label
                        htmlFor="forgot-two-mdp"
                        className={`signin__lab ${(this.state.mdpFocus || this.state.form.mdp != '') && "signin__lab--reduce"}`}
                    >
                        Mot de passe *
                    </label>
                    <input
                        type="password"
                        className="signin__inp"
                        id="forgot-two-mdp"
                        required
                        value={this.state.form.mdp}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    mdp: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({mdpFocus: true})}
                        onBlur={() => this.setState({mdpFocus: false})}
                    />
                </div>

                {/** Confirmation mot de passe **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir la confirmation du mot de passe"
                    aria-label="Assurez-vous de saisir la confirmation du mot de passe"
                >
                    <label
                        htmlFor="forgot-two-mdpconf"
                        className={`signin__lab ${(this.state.mdpConfFocus || this.state.form.mdpConf != '') && "signin__lab--reduce"}`}
                    >
                        Confirmation du mot de passe *
                    </label>
                    <input
                        type="password"
                        className="signin__inp"
                        id="forgot-two-mdpconf"
                        required
                        value={this.state.form.mdpConf}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    mdpConf: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({mdpConfFocus: true})}
                        onBlur={() => this.setState({mdpConfFocus: false})}
                    />  
                </div>

                {/** Bouton validation **/}
                <button
                    title="Modifier mon mot de passe"
                    aria-label="Modifier mon mot de passe"
                    className="signin__btn"
                    type="button"
                    onClick={(el) => this.handleForgot(el)}
                >
                    Enregistrer
                </button>
            </form>

            {/** Footer **/}
            <footer className="signin__ftr">
                <button
                    title="Je me souviens de mon mot de passe"
                    aria-label="Je me souviens de mon mot de passe"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signin")}
                >
                    Se connecter
                </button>
                <button
                    title="Pas encore de compte ?"
                    aria-label="Pas encore de compte ?"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signup")}
                >
                    Créer un compte
                </button>
            </footer>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redFgtPwdTwo: state.redFgtPwdTwo
    }
}

const mapDispatchToProps = {
    forgotTwo
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPwdTwo);